export default [
  {
    path: "/mesas_diretoras",
    component: () => import("@/layout/Default"),
    children: [
      {
        name: "mesas_diretoras_list",
        path: "",
        component: () => import("./pages/List"),
        meta: {
          breadcrumbs: [
            {
              label: "Mesas Diretoras",
              to: "mesas_diretoras_list",
            },
          ],
          permission: "mesa-diretora:view",
          title: "Mesas Diretoras",
        },
      },
      {
        name: "mesas_diretoras_create",
        path: "novo",
        component: () => import("./pages/Create"),
        meta: {
          breadcrumbs: [
            {
              label: "Mesas Diretoras",
              to: "mesas_diretoras_list",
            },
          ],
          permission: "mesa-diretora:create",
          title: "Mesas Diretoras - Cadastro",
        },
      },
      {
        name: "mesas_diretoras_edit",
        path: "editar/:id",
        component: () => import("./pages/Edit"),
        meta: {
          breadcrumbs: [
            {
              label: "Mesas Diretoras",
              to: "mesas_diretoras_list",
            },
          ],
          permission: "mesa-diretora:edit",
          title: "Mesas Diretoras - Edição",
        },
      },
    ],
  },
];
